export default __webpack_public_path__ + "static/media/REPORT_PARAMETRI_ICONA1.2ddda6ba.svg";